export default "<aside id=\"pa-toasts-block\">\n    <div class=\"pa-toasts-container\">\n        <div #toastsContainer></div>\n    </div>\n</aside>"